module.exports = __webpack_public_path__ + "static/copper_crm_create_account-71bccc50340e94fb0a666fae8cf638b8.png";